import { Flex } from "antd"
import CustomerPaymentMethodsList from "./CustomerPaymentMethodsList"
import { useInvoicingSettingsQuery } from "../../../domain/invoicing/settings/invoicingSettingsQueries"
import VSpace from "../../common/VSpace"
import useFeatureFlag from "../../../hooks/useFeatureFlag"
import AddPaymentMethodButton from "./AddPaymentMethodButton"

const CustomerPaymentMethods = ({ customerId }: { customerId: number }) => {
  const invoicingSettingsQuery = useInvoicingSettingsQuery()
  const featureEnabled = useFeatureFlag('show-customer-payment-methods')

  if (!featureEnabled || invoicingSettingsQuery.isLoading || invoicingSettingsQuery.data?.invoicingSystem !== 'synkedUp') {
    return null
  }

  return <section>
    <VSpace>
      <Flex justify="space-between" align="center">
        <strong>Payment Methods on File</strong>
        <AddPaymentMethodButton customerId={customerId} />
      </Flex>
      <CustomerPaymentMethodsList customerId={customerId} />
    </VSpace>
  </section>
}

export default CustomerPaymentMethods
